<template>
    <div>
        <b-modal
            id="m-request-edit-emas"
            :title="mode.title"
            size="xl"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            @show="init"
        >
            <!-- Section: Informasi Barang -->
            <h6 class="section-title">
                <i class="fa fa-tag mr-2"></i>Informasi Barang
            </h6>
            <hr class="section-hr" />
            <b-row>
                <b-col md="6">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Jenis Barang <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            v-model="input.kind"
                            :allow-empty="false"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            :disabled="fetch"
                            @input="onKindChange"
                            placeholder="-- Pilih Salah Satu --"
                            :options="kinds"
                        />
                    </b-form-group>
                </b-col>

                <!-- Non-Perhiasan: Merk Barang -->
                <b-col md="6" v-if="!itemFlags.isPerhiasan">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Merk Barang <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            :disabled="fetch || !input.kind"
                            v-model="input.brand"
                            :allow-empty="false"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            @input="fetchTipeBarang"
                            placeholder="-- Pilih Salah Satu --"
                            :options="brands"
                        />
                    </b-form-group>
                </b-col>

                <!-- Non-Perhiasan: Tipe Barang -->
                <b-col md="6" v-if="!itemFlags.isPerhiasan">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Tipe Barang <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            :disabled="fetch || !input.brand"
                            v-model="input.type"
                            :allow-empty="false"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            placeholder="-- Pilih Salah Satu --"
                            :options="types"
                        />
                    </b-form-group>
                </b-col>

                <!-- Perhiasan: Tipe Emas -->
                <b-col md="6" v-if="itemFlags.isPerhiasan">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Tipe Emas <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            :disabled="fetch"
                            v-model="input.goldType"
                            :allow-empty="false"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            placeholder="-- Pilih Salah Satu --"
                            :options="goldTypes"
                        />
                    </b-form-group>
                </b-col>

                <!-- Perhiasan: Ada Cap -->
                <b-col md="6" v-if="itemFlags.isPerhiasan">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Ada Cap <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            v-model="input.hasMark"
                            label="name"
                            :options="optBoolean"
                            @input="onHasMarkChange"
                            placeholder="-- Pilih Salah Satu --"
                        />
                    </b-form-group>
                </b-col>

                <!-- Perhiasan: Cap (jika Ada Cap = Ya) -->
                <b-col md="6" v-if="itemFlags.isPerhiasan && isHasMark">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Cap <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            :disabled="fetch"
                            v-model="input.mark"
                            :allow-empty="true"
                            label="purity"
                            track-by="id"
                            :internal-search="true"
                            placeholder="-- Pilih Salah Satu --"
                            :options="goldCarats"
                            @input="onMarkChange"
                        />
                    </b-form-group>
                </b-col>

                <!-- Perhiasan: Merk Cap Emas -->
                <b-col md="6" v-if="itemFlags.isPerhiasan">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Merk Cap Emas <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            :disabled="fetch"
                            v-model="input.goldMintMark"
                            :allow-empty="false"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            placeholder="-- Pilih Salah Satu --"
                            :options="optGoldMintMarks"
                        />
                    </b-form-group>
                </b-col>

                <!-- Perhiasan: Jumlah Keping -->
                <b-col md="6" v-if="itemFlags.isPerhiasan">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Jumlah Keping <span style="color: red;">*</span>
                        </template>
                        <b-input-group append="pcs">
                            <b-form-input
                                v-model="input.pieceCount"
                                type="number"
                                placeholder="Masukkan jumlah keping"
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <!-- Perhiasan: Cap Getok -->
                <b-col md="6" v-if="itemFlags.isPerhiasan">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Cap Getok <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            v-model="input.isStamped"
                            label="name"
                            :options="optBoolean"
                            placeholder="-- Pilih Salah Satu --"
                        />
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- Section: Data Temuan -->
            <h6 class="section-title mt-3">
                <i class="fa fa-search mr-2"></i>Data Temuan
            </h6>
            <hr class="section-hr" />
            <b-row>
                <b-col md="6">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Berat Kotor <span style="color: red;">*</span>
                            <small class="text-muted ml-1">(Gunakan titik "." untuk desimal)</small>
                        </template>
                        <b-input-group append="gr">
                            <b-form-input
                                v-model="input.dry_weight"
                                step="0.01"
                                placeholder="Masukkan Berat Kotor"
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Berat Potongan <span style="color: red;">*</span>
                            <small class="text-muted ml-1">(Gunakan titik "." untuk desimal)</small>
                        </template>
                        <b-input-group append="gr">
                            <b-form-input
                                v-model="input.weight_reduction"
                                step="0.01"
                                placeholder="Masukkan Berat Potongan"
                            />
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Kadar XRF <span style="color: red;">*</span>
                        </template>
                        <b-form-input
                            v-model="input.purity"
                            step="0.01"
                            placeholder="Masukkan Kadar XRF"
                            :disabled="isHasMark"
                            :state="purityState"
                        />
                        <b-form-invalid-feedback :state="purityState">
                            <span v-if="input.purity > 1000">
                                Kadar tidak boleh lebih dari 1000
                            </span>
                            <span v-else-if="itemFlags.isLMRetro && input.purity < 850">
                                Kadar untuk LM Retro harus berada di antara 850 dan 1000
                            </span>
                            <span v-else>
                                Kadar tidak valid
                            </span>
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Kategori <span style="color: red;">*</span>
                        </template>
                        <multiselect
                            v-model="input.category"
                            :allow-empty="true"
                            label="name"
                            track-by="id"
                            :internal-search="true"
                            placeholder="Pilih Kategori"
                            :options="optCategory"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="6" v-if="itemFlags.isLMScan">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Tahun
                        </template>
                        <b-form-select v-model="input.year" :options="yearOptions">
                            <template #first>
                                <b-form-select-option :value="null">-- Pilih Tahun --</b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- Section: Media -->
            <h6 class="section-title mt-3">
                <i class="fa fa-photo mr-2"></i>Media
            </h6>
            <hr class="section-hr" />
            <b-row>

                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Foto dan Video (Max 10)<span style="color: red;">*</span>
                        </template>
                        <b-form-file
                            ref="fileInput"
                            v-model="tempPhotos"
                            placeholder="Tambah foto dan video..."
                            drop-placeholder="Drop file disini..."
                            multiple
                            accept="image/*,video/*"
                            :file-name-formatter="formatNames"
                            @change="onFileChange"
                        />
                        <div class="mt-2 text-muted" v-if="localPhotos.length > 0">
                            {{ localPhotos.length }} file dipilih
                        </div>
                    </b-form-group>
                    <div v-if="previews.length" class="d-flex flex-wrap mt-2">
                        <div
                            v-for="(preview, index) in previews"
                            :key="index"
                            class="mr-2 mb-2 position-relative"
                        >
                            <img
                                v-if="preview.type === 'image'"
                                :src="preview.url"
                                class="img-thumbnail"
                                style="width: 100px; height: 100px; object-fit: cover;"
                            />
                            <video
                                v-else-if="preview.type === 'video'"
                                :src="preview.url"
                                class="img-thumbnail"
                                style="width: 100px; height: 100px; object-fit: cover;"
                                preload="metadata"
                            ></video>
                            <b-button
                                size="sm"
                                variant="danger"
                                class="position-absolute"
                                style="top: 0; right: 0; padding: 0 4px; z-index: 999;"
                                @click="removePhoto(index)"
                            >
                                &times;
                            </b-button>
                            <div
                                class="overlay-trigger"
                                style="position:absolute; top:0; left:0; width:100%; height:100%; cursor: pointer; z-index: 0;"
                                @click="showPreviewModal(preview)"
                            >
                                <div
                                    v-if="preview.type === 'video'"
                                    style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: white; background-color: rgba(0,0,0,0.5); border-radius: 50%; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center;"
                                >
                                    <i class="fa fa-play"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
            </b-row>

            <!-- Section: Catatan -->
            <h6 class="section-title mt-3">
                <i class="fa fa-pencil mr-2"></i>Catatan
            </h6>
            <hr class="section-hr" />
            <b-row>
                <b-col md="12">
                    <b-form-group label-class="font-weight-bold">
                        <template #label>
                            Catatan <span style="color: red;">*</span>
                        </template>
                        <b-form-textarea
                            id="notes"
                            v-model="input.notes"
                            placeholder="Masukkan catatan temuan"
                            rows="4"
                            maxlength="1000"
                        />
                        <small :class="notesCharCount > 1000 ? 'text-danger' : 'text-muted'">
                            {{ notesCharCount }} / 1000
                        </small>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-modal
                id="m-preview-photo"
                title="Preview Media"
                size="lg"
                hide-footer
            >
                <img
                    v-if="selectedPreviewImage && selectedPreviewImage.type === 'image'"
                    :src="selectedPreviewImage.url"
                    class="img-fluid"
                    width="100%"
                />
                <video
                    v-else-if="selectedPreviewImage && selectedPreviewImage.type === 'video'"
                    :src="selectedPreviewImage.url"
                    class="img-fluid"
                    width="100%"
                    controls
                    autoplay
                ></video>
            </b-modal>

            <div class="text-right mt-3">
                <b-button
                    variant="primary"
                    @click="submitFindings"
                    :disabled="isSubmitting"
                >
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
            <loading-overlay
                :fotoStartTime="uploadTimeStamp.startPresignedUrl"
                :fotoEndTime="uploadTimeStamp.endPresignedUrl"
                :uploadStartTime="uploadTimeStamp.startUploadToS3"
                :uploadEndTime="uploadTimeStamp.endUploadToS3"
                :penyimpananStartTime="uploadTimeStamp.startSaveFile"
                :penyimpananEndTime="uploadTimeStamp.endSaveFile"
                :show="isShowLoadingOverlay"
            />
        </b-modal>
    </div>
</template>

<script>
import LoadingOverlay from "../barang-masuk/LoadingOverlay.vue";

export default {
    components: {
        LoadingOverlay
    },
    name: "ModalRequestEditEmas",
    props: {
        item: {
            type: Object,
            default: () => null
        },
        // Temuan penerimaan PGI/SGP (approval barang masuk) instead of a reset request.
        receipt: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            input: {
                dry_weight: null,
                purity: null,
                weight_reduction: null,
                notes: null,
                category: null,
                kind: null,
                brand: null,
                type: null,
                goldType: null,
                hasMark: null,
                mark: null,
                goldMintMark: null,
                pieceCount: null,
                isStamped: null,
                year: null
            },
            tempPhotos: [],
            localPhotos: [],
            previews: [],
            selectedPreviewImage: null,
            isSubmitting: false,
            fetch: false,
            uploadTimeStamp: {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            },
            uploadedFilePaths: [],
            isShowLoadingOverlay: false,

            optCategory: [],
            kinds: [],
            brands: [],
            types: [],
            goldTypes: [],
            goldCarats: [],
            optGoldMintMarks: [],
            optBoolean: [
                { name: "Ya", value: true },
                { name: "Tidak", value: false }
            ]
        };
    },
    computed: {
        // Temuan penerimaan (approval barang masuk) vs request edit (inventory).
        mode() {
            if (this.receipt) {
                return {
                    title: "Buat Temuan",
                    dir: { PGI: "penerimaan-pgi/findings", SGP: "penerimaan-sgp/findings" }[this.item && this.item.source],
                    categoryQuery: "&source=IVN",
                    confirmText: "Apakah Anda yakin akan membuat temuan ini?",
                    idKey: "origin_id",
                    endpoint: "gold-receipt-variances",
                    successText: "Temuan berhasil dibuat"
                };
            }
            return {
                title: "Request Edit Emas",
                dir: "gold-reset",
                categoryQuery: "",
                confirmText: "Apakah Anda yakin akan request edit emas ini?",
                idKey: "inventory_id",
                endpoint: "gold-reset-requests",
                successText: "Request edit berhasil dibuat"
            };
        },
        notesCharCount() {
            if (!this.input.notes) return 0;
            return this.input.notes.length;
        },
        itemFlags() {
            return {
                isPerhiasan: this.input.kind && this.input.kind.id === 257,
                isLMRetro: this.input.kind && this.input.kind.id === 261,
                isLMScan: this.input.kind && this.input.kind.id === 251
            };
        },
        yearOptions() {
            const current = new Date().getFullYear();
            const years = [];
            for (let y = current; y >= 2000; y--) {
                years.push(String(y));
            }
            return years;
        },
        isHasMark() {
            return this.input.hasMark && this.input.hasMark.value === true;
        },
        purityState() {
            if (this.input.purity === null || this.input.purity === "") {
                return null;
            }
            const val = Number(this.input.purity);
            if (isNaN(val)) return false;
            if (val < 0 || val > 1000) return false;
            if (this.itemFlags.isLMRetro && val < 850) {
                return false;
            }
            return true;
        }
    },
    watch: {
        item(newItem) {
            if (!newItem) {
                return;
            }
            this.resetForm();
        }
    },
    methods: {
        init() {
            this.resetForm();
            Promise.all([
                this.getCategoryVariance(),
                this.fetchJenisBarang(),
                this.fetchGoldType(),
                this.fetchGoldCarats(),
                this.fetchGoldMintMark()
            ]);
        },

        async getCategoryVariance() {
            await this.$axios.get(`master/gold-variance-categories?for=SM${this.mode.categoryQuery}`)
                .then(response => {
                    this.optCategory = response.data.data;
                })
                .catch(error => {
                    this.$helper.parseError(this, error);
                });
        },

        async fetchJenisBarang() {
            this.fetch = true;
            await this.$axios
                .get("master/kinds?category=EMAS")
                .then(res => {
                    this.kinds = res.data.data.filter(
                        item => item.id != 246 && item.id != 252
                    );
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchMerkBarang() {
            this.input.brand = null;
            this.input.type = null;
            this.brands = [];
            this.types = [];
            if (!this.input.kind) return;
            this.fetch = true;
            await this.$axios
                .get(`master/brands/${this.input.kind.id}`)
                .then(res => {
                    this.brands = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchTipeBarang() {
            this.input.type = null;
            this.types = [];
            if (!this.input.brand) return;
            this.fetch = true;
            await this.$axios
                .get(`master/types/${this.input.brand.id}`)
                .then(res => {
                    this.types = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchGoldType() {
            this.fetch = true;
            await this.$axios
                .get("master/gold-type")
                .then(res => {
                    this.goldTypes = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        async fetchGoldCarats() {
            this.fetch = true;
            await this.$axios
                .get("master/gold-carats")
                .then(res => {
                    this.goldCarats = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },
 
        async fetchGoldMintMark() {
            this.fetch = true;
            await this.$axios
                .get("master/gold-mint-mark")
                .then(res => {
                    this.optGoldMintMarks = res.data.data;
                })
                .finally(() => {
                    this.fetch = false;
                });
        },

        onKindChange() {
            this.input.brand = null;
            this.input.type = null;
            this.input.goldType = null;
            this.input.hasMark = null;
            this.input.mark = null;
            this.input.goldMintMark = null;
            this.input.pieceCount = null;
            this.input.isStamped = null;
            this.input.year = null;
            this.brands = [];
            this.types = [];
            if (!this.itemFlags.isPerhiasan) {
                this.fetchMerkBarang();
            }
        },

        onHasMarkChange(val) {
            if (!val || val.value === false) {
                this.input.mark = null;
                this.input.purity = null;
            }
        },

        onMarkChange(val) {
            if (val && val.purity !== null && val.purity !== undefined) {
                this.input.purity = val.purity;
            } else {
                this.input.purity = null;
            }
        },

        async getPresignedUrl(fileName, fileType) {
            this.uploadTimeStamp.startPresignedUrl = this.formatTime(
                new Date()
            );
            const payload = {
                file_name: fileName,
                file_type: fileType,
                reference_key: this.item.no_faktur,
                directory_path: this.mode.dir
            };
            const response = await this.$axios.post(
                "get-presigned-url",
                payload
            );
            this.uploadTimeStamp.endPresignedUrl = this.formatTime(new Date());
            return response.data.data;
        },

        async uploadToS3(file, presignedUrl) {
            this.uploadTimeStamp.startUploadToS3 = this.formatTime(new Date());
            const response = await fetch(presignedUrl, {
                method: "PUT",
                body: file,
                headers: {
                    "Content-Type": file.type
                }
            });
            if (!response.ok) throw new Error("Upload to S3 failed");
            this.uploadTimeStamp.endUploadToS3 = this.formatTime(new Date());
            return response;
        },

        resetForm() {
            this.input = {
                dry_weight: null,
                purity: null,
                notes: null,
                category: null,
                weight_reduction: null,
                kind: null,
                brand: null,
                type: null,
                goldType: null,
                hasMark: null,
                mark: null,
                goldMintMark: null,
                pieceCount: null,
                isStamped: null,
                year: null
            };
            this.localPhotos = [];
            this.tempPhotos = [];
            this.previews = [];
            this.uploadedFilePaths = [];
        },
        async onFileChange(e) {
            if (
                !e ||
                !e.target ||
                !e.target.files ||
                e.target.files.length === 0
            ) {
                return;
            }
            const newFiles = Array.from(e.target.files);

            if (this.localPhotos.length + newFiles.length > 10) {
                this.$helper.toastError(this, "Maksimal 10 foto diperbolehkan");
                this.tempPhotos = [];
                return;
            }

            this.isShowLoadingOverlay = true;

            try {
                const uploadPromises = newFiles.map(async (file) => {
                    const {
                        presigned_url,
                        file_path
                    } = await this.getPresignedUrl(file.name, file.type);

                    await this.uploadToS3(file, presigned_url);
                    return `${this.mode.dir}/${this.item.no_faktur}/${file_path}`;
                });

                const uploadedPaths = await Promise.all(uploadPromises);
                this.uploadedFilePaths.push(...uploadedPaths);

                this.uploadTimeStamp.startSaveFile = this.formatTime(new Date());
                this.uploadTimeStamp.endSaveFile = this.formatTime(new Date());

                this.localPhotos = [...this.localPhotos, ...newFiles];
                this.generatePreviews();
            } catch (error) {
                this.$helper.toastError(this, "Gagal mengupload foto");
            } finally {
                this.$nextTick(() => {
                    this.tempPhotos = [];
                });
                this.isShowLoadingOverlay = false;
                this.resetUploadTimestamp();
            }
        },
        resetUploadTimestamp() {
            this.uploadTimeStamp = {
                startPresignedUrl: null,
                endPresignedUrl: null,
                startUploadToS3: null,
                endUploadToS3: null,
                startSaveFile: null,
                endSaveFile: null
            };
        },
        generatePreviews() {
            this.previews = [];
            if (!this.localPhotos) return;

            this.localPhotos.forEach(file => {
                this.previews.push({
                    url: URL.createObjectURL(file),
                    type: file.type.startsWith('video/') ? 'video' : 'image'
                });
            });
        },
        removePhoto(index) {
            const newPhotos = [...this.localPhotos];
            newPhotos.splice(index, 1);
            this.localPhotos = newPhotos;

            const newPaths = [...this.uploadedFilePaths];
            newPaths.splice(index, 1);
            this.uploadedFilePaths = newPaths;

            this.previews.splice(index, 1);

            this.generatePreviews();
        },
        validateForm() {
            const rules = [
                { isValid: !!this.input.kind, message: "Jenis Barang wajib dipilih" }
            ];
 
            if (this.itemFlags.isPerhiasan) {
                rules.push(
                    { isValid: !!this.input.goldType, message: "Tipe Emas wajib dipilih" },
                    { isValid: !!this.input.hasMark, message: "Status Ada Cap wajib dipilih" },
                    { isValid: !this.isHasMark || !!this.input.mark, message: "Cap wajib dipilih" },
                    { isValid: !!this.input.goldMintMark, message: "Merk Cap Emas wajib dipilih" },
                    { isValid: this.input.pieceCount !== null && this.input.pieceCount !== "", message: "Jumlah Keping wajib diisi" },
                    { isValid: !!this.input.isStamped, message: "Cap Getok wajib dipilih" }
                );
            } else {
                rules.push(
                    { isValid: !!this.input.brand, message: "Merk Barang wajib dipilih" },
                    { isValid: !!this.input.type, message: "Tipe Barang wajib dipilih" }
                );
            }
 
            rules.push(
                { isValid: !!this.input.dry_weight, message: "Berat Kotor wajib diisi" },
                { isValid: !!this.input.weight_reduction, message: "Berat Potongan wajib diisi" },
                { isValid: parseFloat(this.input.weight_reduction) <= parseFloat(this.input.dry_weight), message: "Berat Potongan tidak boleh lebih besar dari Berat Kotor" },
                { isValid: !!this.input.purity, message: "Kadar XRF wajib diisi" },
                { isValid: !!this.input.category, message: "Kategori wajib dipilih" },
                { isValid: !!this.input.notes, message: "Catatan wajib diisi" },
                { isValid: this.notesCharCount <= 1000, message: "Catatan maksimal 1000 karakter" },
                { isValid: this.localPhotos.length > 0, message: "Foto dan video wajib diupload" }
            );

            if (this.input.kind && this.input.kind.id === 261 && this.input.purity) {
                const purityVal = parseFloat(this.input.purity);
                rules.push({
                    isValid: purityVal >= 850 && purityVal <= 1000,
                    message: "Kadar untuk LM Retro harus berada di antara 850 dan 1000"
                });
            }
 
            const firstFailed = rules.find(rule => !rule.isValid);
            return firstFailed ? firstFailed.message : null;
        },
        
        async submitFindings() {
            const errorMessage = this.validateForm();
            if (errorMessage) {
                this.$helper.toastError(this, errorMessage);
                return;
            }

            this.isSubmitting = true;

            try {
                let isConfirmed = confirm(
                    this.mode.confirmText
                );
                if (!isConfirmed) {
                    return;
                }
 
                const payload = {
                    [this.mode.idKey]: this.item.id,
                    origin_type: "IVN",
                    dry_weight: parseFloat(this.input.dry_weight).toFixed(2),
                    purity: this.input.purity,
                    weight_reduction: parseFloat(this.input.weight_reduction).toFixed(4),
                    category: this.input.category.name,
                    notes: this.input.notes,
                    media: this.uploadedFilePaths, 
                    new_item_kind_id: this.input.kind ? this.input.kind.id : null,
                    new_item_type_id: this.itemFlags.isPerhiasan ? null : (this.input.type ? this.input.type.id : null),
                    gold_type_id: this.input.goldType ? this.input.goldType.id : null,
                    has_mark: this.input.hasMark ? this.input.hasMark.value : null,
                    gold_mint_mark_id: this.input.goldMintMark ? this.input.goldMintMark.id : null,
                    piece_count: this.input.pieceCount ? parseInt(this.input.pieceCount) : null,
                    is_stamped: this.input.isStamped ? this.input.isStamped.value : null,
                    year: this.input.year || null,
                };
 
                await this.$axios.post(this.mode.endpoint, payload);
                this.resetForm();
                this.$helper.toastSuccess(this, this.mode.successText);
                this.$bvModal.hide("m-request-edit-emas");
                this.$emit("refresh-items");
            } catch (error) {
                this.$helper.parseError(this, error);
            } finally {
                this.isSubmitting = false;
            }
        },
        showPreviewModal(image) {
            this.selectedPreviewImage = image;
            this.$bvModal.show("m-preview-photo");
        },
        formatNames() {
            return "Tambah Foto...";
        },
        formatTime(date) {
            const hh = String(date.getHours()).padStart(2, "0");
            const mm = String(date.getMinutes()).padStart(2, "0");
            const ss = String(date.getSeconds()).padStart(2, "0");
            return `${hh}:${mm}:${ss}`;
        }
    }
};
</script>

<style scoped>
.section-title {
    font-weight: bold;
    color: #4f5d73;
}
.section-hr {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    border-top: 1px solid #c8ced3;
}
</style>
